import React from 'react';

import { VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';

import type { RestrictionsDialogTriggerProps } from '../types';

import { RestrictionsDialogTrigger } from './RestrictionsDialogTrigger';

export const RestrictionsDialogTriggerWrapper = (props: RestrictionsDialogTriggerProps) => {
	const { accessStatus } = useSessionData();

	const hasAccess =
		accessStatus === AccessStatus.LICENSED_USE_ACCESS ||
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;

	return (
		<ErrorBoundary
			attribution={Attribution.PERMISSIONS_EXPERIENCE}
			key="restrictions-dialog-trigger"
		>
			{hasAccess ? (
				<>
					<ExperienceStart
						key="restriction-button-start"
						id={props.contentId}
						name={VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE}
					/>
					<RestrictionsDialogTrigger {...props} />
				</>
			) : null}
		</ErrorBoundary>
	);
};
